<script lang="ts">
    import Footer from "../footer/Footer.svelte";
    import { _ } from "svelte-i18n";
    import Title from "./Title.svelte";
    import Logos from "./Logos.svelte";
    import Explainer from "./Explainer.svelte";
    import Testimonial from "./Testimonial.svelte";
    import Media from "./Media.svelte";
    import FaQs from "./FAQs.svelte";
    import CallToAction from "./CallToAction.svelte";
    import Pricing from "./pricing/Pricing.svelte";
    import CommunicateNavbar from "./CommunicateNavbar.svelte";
    import Demo from "./Demo.svelte";
    import What from "./What.svelte";
    import CommunicateFooter from "./CommunicateFooter.svelte";
</script>

<svelte:head>
    <title>ANYWAYS | {$_("communicate.title.title")} | {$_("communicate.title.title2")}</title>
</svelte:head>

<CommunicateNavbar isFluid={false} background="none" text="white"/>

<Title />


<What />

<Explainer />

<Testimonial />

<Media />

<Logos />

<Pricing />

<FaQs />

<CallToAction />

<CommunicateFooter bgClass="bg-dark" />
